// custom js    

//sticky main menu 
 
var stickyMenu = jQuery('.menu-section').length > 0 ? jQuery('.menu-section').offset().top : null;
  
jQuery(window).scroll(function() { 
		if(stickyMenu !== null){		
			if (jQuery(window).scrollTop() > stickyMenu) {
					jQuery('.menu-section').addClass('affix');
			}
			else {
					jQuery('.menu-section').removeClass('affix');
			}  
		}
});

//OPEN SIGN UP AND LOG IN POPUP WITH HASH PARAM
jQuery(document).ready(function(){
	if(window.location.hash == '#login'){
		$('#login').foundation('open');
	}
	if(window.location.hash == '#signup'){
		$('#signup').foundation('open');
	}
	if(window.location.hash == '#join'){
		$('#login-callout').foundation('open');
	}
})

//anchor links, smooth scrolling, and active state on main nav

		jQuery(document).on("scroll", onScroll);
		
		//smoothscroll
		jQuery('#main-menu a[href^="#"]').on('click', function (e) {
			e.preventDefault();
			jQuery(document).off("scroll");
			
			jQuery('a').each(function () {
					jQuery(this).removeClass('active');
			})
			jQuery(this).addClass('active');
		
			var target = this.hash,
					menu = target;
			jQuerytarget = jQuery(target);
			jQuery('html, body').stop().animate({
					'scrollTop': jQuerytarget.offset().top -45
			}, 500, 'swing', function () {
					window.location.hash = target;
					jQuery(document).on("scroll", onScroll);
			});
		});

function onScroll(event){ //
	var scrollPos = jQuery(document).scrollTop();
	jQuery('#main-menu .horizontal a').each(function () {
		var currLink = jQuery(this);
		var refElement = jQuery(currLink.attr("href"));

		if (refElement.position() !== undefined && refElement.position().top < scrollPos && refElement.position().top + refElement.outerHeight() - 0.5 >= scrollPos) {
			currLink.addClass("active");
		} else {
			currLink.removeClass("active");
		}
	});
}

// mobile dropdown 
	jQuery("#main-menu .button-holder a").click(function(){
		jQuery("#main-menu .mobile-menu ul.drop-menu").slideToggle("fast");
});

//Open/close tootlip in stats section
function repositionToolbox(toolClick) {
	var $ = jQuery;
	var toolbox = $(toolClick).parent().find(".tool-box");

	var value = $(window).width() - ($(toolClick).offset().left + $(toolbox).width());

	if(value <= 0){
		$(toolbox).css("left", "auto");
		$(toolbox).css("right", "0px");
	}else{
		$(toolbox).css("left", "25px");
		$(toolbox).css("right", "auto");	
	}


	toolbox.addClass("toolbox-opened");
	toolbox.fadeIn( "slow");
}


jQuery( ".data-section .tooltip-section a.tool-click" ).click(function() {
	repositionToolbox(jQuery(this));  
});

jQuery(document).ready(function() {   
        // Detect ios 11_0_x affected 
        // NEEDS TO BE UPDATED if new versions are affected
        var ua = navigator.userAgent,
        iOS = /iPad|iPhone|iPod/.test(ua),
        iOS11 = /OS 11_0|OS 11_0_1|OS 11_0_2|OS 11_0_3|OS 11_1|OS 11_1_1|OS 11_1_2/.test(ua);
        if(iOS){
            jQuery("body").addClass("ios-device");
        }
        // ios 11 bug caret position
        if ( iOS && iOS11 ) {
            // Add CSS class to body
            jQuery("body").addClass("iosBugFixCaret");

            /*
            jQuery("#interests.reveal").css({
            	"height" : "100% !important",
            	"top"  :  "0px"
            });
            jQuery("#interests.reveal").find(".interests").css("overflow-y", "auto");
            */
        }
    
	jQuery(window).on("resize", function () {
		jQuery( ".data-section .tooltip-section .tool-box.toolbox-opened" ).each(function () {
			var toolClick = jQuery(this).parent().find(".tool-click");

			var value = jQuery(window).width() - (jQuery(toolClick).offset().left + jQuery(this).width());

			if(value <= 0){
				jQuery(this).css("left", "auto");
				jQuery(this).css("right", "0px");
			}else{
				jQuery(this).css("left", "25px");
				jQuery(this).css("right", "auto");	 
			}
		});
	});
});

jQuery( ".data-section .tooltip-section .tool-box a" ).click(function() {
	jQuery( this ).parent().parent().parent().fadeOut( "fast");
	jQuery( this ).parent().parent().parent().removeClass("toolbox-opened");
});

//isotope filtering in Support Community section adapted from http://fiddle.jshell.net/9pSyj/12/
/*
jQuery(function () {
		var jQuerycontainer = jQuery('#container');
		jQuerycontainer.isotope({

		});
		jQuery('.filter').change(function () {
		 var selected = [];
		jQuery('.filter option').filter(':selected').each(function () {
						if (this.value != "*") {
								selected.push(this.value);
						}
				});
				if (selected.length === 0) {
						selected.push("*");
				}
				selected = jQuery(selected.join(''));

				jQuerycontainer.isotope({
						filter: selected
				});
		});
});*/

// sticky sidebar nav

jQuery(".menu-column").stick_in_parent();

// smooth scrolling, left sidebar

jQuery("#implementation .menu-column ul li a[href*=\\#]:not([href=\\#])").click(function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname) {

				var target = jQuery(this.hash);
				target = target.length ? target : jQuery('[name=' + this.hash.slice(1) +']');
					 if (target.length) {
						 jQuery('html,body').animate({
								 scrollTop: target.offset().top-80
						}, 1000);
						return false;
				}
		}
});

//active classes on sidebar nav on homepage

// Cache selectors
var lastId,
		topMenu = jQuery("#implementation .menu-column"),
		topMenuHeight = topMenu.outerHeight(),
		// All list items
		menuItems = topMenu.find("li.main-class a"),
		// Anchors corresponding to menu items
		scrollItems = menuItems.map(function(){
			var item = jQuery(jQuery(this).attr("href"));
			if (item.length) { return item; }
		});

// Bind to scroll
jQuery(window).scroll(function(){
	 // Get container scroll position
	 var fromTop = jQuery(this).scrollTop()+topMenuHeight;
	 
	 // Get id of current scroll item
	 var cur = scrollItems.map(function(){
		 if (jQuery(this).offset().top < fromTop)
			 return this;
	 });
	 // Get the id of the current element
	 cur = cur[cur.length-1];
	 var id = cur && cur.length ? cur[0].id : "";
	 
	 if (lastId !== id) {
			 lastId = id;
			 // Set/remove active class
			 menuItems
				 .parent().removeClass("active")
				 .end().filter("[href='#"+id+"']").parent().addClass("active");
	 }   

	 jQuery(function() {
		 jQuery("li.main-class").each(function() {
				if (jQuery(this).hasClass('active')) {
					jQuery(this).parents('ul').addClass('active');
				} else {
					jQuery(this).parents('ul').removeClass('active');
				}
			});
		});
});

// Accordion adapted from https://github.com/gbbr/UberAccordion
var $accordions = [];
jQuery(window).ready(function () {
	jQuery(".accordionContainer").each(function () {
		var orientation = "horizontal";

		if(jQuery(window).width() > 1023 ){
		//if(jQuery(window).width() > 639 ){
			orientation = "vertical";
		}

		var instance = jQuery(this).uberAccordion({
			headerClass: "title",
			contentClass: "content",
			orientation: orientation,
			orientationQuery: "(max-width: 1023px)"
			//orientationQuery: "(max-width: 639px)"
		});
	
		$accordions.push( instance );

		instance.setOrientation(orientation);
	
	});
})

jQuery(window).on("resize", function() {
	var orientation = "horizontal";
	
	//if(jQuery(window).width() > 639 ){
	if(jQuery(window).width() > 1023 ){
		orientation = "vertical";
	}

	for(var i = 0; i < $accordions.length; i++) {
		$accordions[i].setOrientation(orientation);
	}
});


//Header search function
jQuery('[cca-menu] .menu li.search-container input.search-input').on("keyup", function(e) {
	var $ = jQuery;
	if(e.keyCode == 13){
		window.location.href = $(this).attr('data-search-page-url') + '?search=' + $(this).val();
	}
});

jQuery('[cca-menu] .menu li.search-container button').on("click", function(e) {
	var $ = jQuery;
	var $input = $('[cca-menu] .menu li.search-container input.search-input');
	if($input.length && $input.val() !== ''){
		window.location.href = $input.attr('data-search-page-url') + '?search=' + $input.val();
	}
});

//activate chosen plugin to style select boxes

jQuery(".filter").chosen();
jQuery(".mobile-drop").chosen();
jQuery(".chart-dropdowns").chosen({

});

//Select box anchor tags adapted from here: http://jsfiddle.net/kgzwE/1/

//jQuery('.mobile-drop').change( function () {
//    var targetPosition = jQuery(jQuery(this).val()).offset().top-100;
//    jQuery('html,body').animate({ scrollTop: targetPosition}, 'slow');
//});

//Fade out video placeholder image on click
	jQuery("#overview .video-section .video-holder iframe").addClass("youtube-player");
	jQuery( "#overview .video-section .video-holder .video-play a" ).click(function(ev) {
		jQuery(this).parents( "#overview .video-section .video-holder" ).addClass( "fade-out" );
		jQuery(".youtube-player")[0].src += "?enablejsapi=1&autoplay=1";
			ev.preventDefault();
	});

//Add class to chart

//jQuery("#overview .chart-select .chzn-container-single a span:contains('Demographic Breakdown')").each(function(i , v){
//    jQuery(this).closest(".chzn-single").css("background-color" , "blue");
//});

jQuery('#overview .chart-select .chzn-container-single a').addClass('main-cat');

jQuery("#overview .chart-select").click(function(){
		jQuery(".chzn-container-single a").removeClass("main-cat");
});

//Custom toggles
jQuery(".cca-switch input.switch-input").on("change", function (evt) {
	var selected = jQuery(this).is(":checked") ? "right" : "left";
	jQuery(this).parent().find(".switch-labels."+selected).addClass("selected");
	jQuery(this).parent().find(".switch-labels:not(."+selected+")").removeClass("selected");
});

/**
jQuery(".related-content-container .blocks-container").each(function () {
	var $ = jQuery;
	var maxHeight = 0;
	var boxes = $(this).find(".resources-box");
	$.each(boxes, function (i, box) {
		if($(box).outerHeight() > maxHeight){
			maxHeight = $(box).outerHeight();
		};
	});

	$.each(boxes, function (i, box) {
		$(box).css("height", maxHeight+"px");
	})

});
//*/

window.isScrolledIntoView = function(elem){
    var $ = jQuery;
    var $elem = $(elem);
    var $window = $(window);

    var docViewTop = $window.scrollTop();
    var docViewBottom = docViewTop + $window.height();

    var elemTop = $elem.offset().top;
    var elemBottom = elemTop + $elem.height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

//ajax for the poeple list   
jQuery(".people-list-container").each(function () {
	var $ = jQuery;
	var rolesDropdown = $(this).find(".roles-dropdown");
	var rolesDropdownContainer = $(this).find(".roles-dropdown-container");
	var OrgTypeDropdown = $(this).find(".organization-type-dropdown");
	var spinnerIcon = $(this).find(".roles-dropdown-container .roles-dropdown-spinner-icon");


	$(OrgTypeDropdown).on("change", function () {
		var selected = $(this).find(":selected").text();
		var params = { action: "get_roles_options", selected: selected };

		spinnerIcon.attr("loading", true);
		rolesDropdownContainer.attr("dropdown-disabled", true);
		$.get(window.homeUrl + "/wp-admin/admin-ajax.php", params, function(data){
			var results = JSON.parse(data);

			$(rolesDropdown).html("");
			$(rolesDropdown).append("<option value='*' selected='selected'>Role</option>");
			
			for (var i = 0; i < results.length; i++) {
				$(rolesDropdown).append("<option value='."+results[i].slug+"'>"+results[i].name+"</option>");
			}

			if(selected !== "Organization Type"){
				rolesDropdownContainer.attr("dropdown-disabled", false);
			}

			spinnerIcon.attr("loading", false);

			$(rolesDropdown).trigger("liszt:updated"); 
		});
	});
});

//animation for featured data point (percentage)
jQuery(".featured-data-point-container.percentage").each(function () { 
	var $ = jQuery;
	var thisEl = $(this);
	var numElement = $(this).find("h1.percent-value");
	var numValue = (parseFloat($(numElement).html())).toFixed(1);
	var timing = numValue / 100 * 2.8;
	var numAnim = new CountUp(numElement[0], 0, numValue, 0, timing,{ useEasing: true, useGrouping: true, separator: ",", decimal: "."});
	var personIcons = $(this).find(".percent-people-container img.person-svg");
	var hasEndedAnimation = false;
	var isCompletionCampaignVariant = $(this).hasClass('completion-campaign-variant');

	var doAnimation = function (personNumValue) {
		numAnim.start();
		var i = 0;
		//animate person
		var requestID;

		var animate = function() {
			requestID = requestAnimationFrame(animate);

			// If the box has not reached the end draw on the canvas.
			// Otherwise stop the animation.
			if (i < personNumValue) {
				var src = jQuery(personIcons[i]).attr("src");
				src = src.replace(src.substr(src.lastIndexOf("/") + 1), isCompletionCampaignVariant ? "user-teal.svg" : "user.svg");
				jQuery(personIcons[i]).attr("src", src);
				i++;
			} else {
				cancelAnimationFrame(requestID);
			}
		}

		animate();

		hasEndedAnimation = true;
	}

	//person animation
	var personNumValue = parseInt((parseInt(numValue)).toFixed(1));
	//count up part
	$(window).scroll(function () {

		if(window.isScrolledIntoView( thisEl ) || hasEndedAnimation){
			doAnimation(personNumValue);
		}
	});

	jQuery(document).ready(function () {
		if(window.isScrolledIntoView( thisEl ) || hasEndedAnimation){
			doAnimation(personNumValue);
		}
	});

});

//animation for featured data point (regular)
jQuery(".featured-data-point-container.regular").each(function () {
	var $ = jQuery;
	var thisEl = $(this);
	var numElement = $(this).find("h1.regular-value span.value");
	var numValue = parseInt($(numElement).html());
	var numAnim = new CountUp(numElement[0], 0, numValue, 0, 1.5,{ useEasing: true, useGrouping: true, separator: ",", decimal: "."});
	var hasEndedAnimation = false;

	var doAnimation = function () {
		numAnim.start();
		hasEndedAnimation = true;
	}

	//count up part
	$(window).scroll(function () {
		if(window.isScrolledIntoView( thisEl ) && !hasEndedAnimation){
			doAnimation();
		}
	});

	$(window).on('load', function () {
		if(window.isScrolledIntoView( thisEl ) && !hasEndedAnimation){
			doAnimation();
		}
	})
});

function initializePeopleListMasonry(containerEl) {
	var $ = jQuery;

	var listType = "small";
	var elementSize;
	var gutterSize;

	if(containerEl.hasClass("list-type-small")){
		gutterSize = parseInt(containerEl.find(".gutter-sizer").css("width"));

		//redo all items height
		var maxHeight = 0;
		var items = containerEl.find(".item.item-type-small");
		$.each(items, function (i, item) { 
			$(item).css("height", "auto");
			var imgHolder = $(item).find(".img-holder");
			var imgHolderWidth = $(imgHolder).width();
			$(imgHolder).css("height", imgHolderWidth + "px");
		});

		$.each(items, function (i, item) {
			if($(item).outerHeight() > maxHeight){
				maxHeight = $(item).outerHeight();
			}
		});
	
		$.each(items, function (i, item) {
			$(item).css("height", maxHeight+"px");
		});

		if($(window).width() > 639){
			elementSize = parseInt(containerEl.find(".grid-sizer").css("width"));
		}else{
			elementSize =  (($(window).width() / 2) - 40);
		}
	}else if(containerEl.hasClass("list-type-large")){
		elementSize = parseInt(containerEl.find(".grid-sizer").css("width"));
		gutterSize = parseInt(containerEl.find(".gutter-sizer").css("width"));
	}else if(containerEl.hasClass("list-type-no_image")){
		elementSize = parseInt(containerEl.find(".grid-sizer").css("width"));
		gutterSize = parseInt(containerEl.find(".gutter-sizer").css("width"));
	}

	containerEl.isotope({
		horizontalOrder: true,
		itemSelector: ".item",
		masonry: {
			columnWidth: elementSize,
			gutter: gutterSize
		}
	});
}

//isotope filtering in Support Community section adapted from http://fiddle.jshell.net/9pSyj/12/
jQuery(window).ready(function () {
	jQuery(".people-list-container").each(function () {
		var $ = jQuery;
		var masonryContainer = $(this).find(".people-masonry-container");
		var filters = $(this).find(".people-filters-container .filter");
	
		//GIVE ALL ITEMS THE SIZE HEIGHT IF TYPE SMALL

		if(masonryContainer.hasClass("list-type-small")){
			var maxHeight = 0;
			var items = $(this).find(".item");
		
			$.each(items, function (i, item) {
				if($(item).outerHeight() > maxHeight){
					maxHeight = $(item).outerHeight();
				}
			});
		
			$.each(items, function (i, item) {
				$(item).css("height", maxHeight+"px");
			});
		}
	
		//Initialize masonry
		initializePeopleListMasonry(masonryContainer);

		$(window).on("resize", function () {
			initializePeopleListMasonry(masonryContainer);
		});
	
		filters.change(function () {
			if($(this).is("[custom-filtering]")) return;

			var selected = [];
			$(filters).find("option").filter(":selected").each(function () {
				if (this.value != "*") {
					selected.push(this.value);
				}
			});
			if (selected.length === 0) {
				selected.push("*");
			}
			selected = $(selected.join(""));
	
			masonryContainer.isotope({
				filter: selected
			});
		});
	
		//clamp text
		var descriptionP = $(this).find(".item .type-large .text-container p.bio, .item .type-no-image p.bio");
		descriptionP.each(function (i, element) {
			var textToClamp = $(element);
			var clampLine = Math.floor($(textToClamp).parent().outerHeight() / parseFloat($(textToClamp).css("line-height")));
			var textHeight = Math.trunc(clampLine) * parseFloat($(textToClamp).css("line-height")) - 3;

			setTimeout(function () {
				$clamp(textToClamp[0], {
					clamp: clampLine
				});
			},100);
			if(checkBroswerType('chrome')){
				$(textToClamp).height(textHeight + "px");
			}

		});
	
	});
})

/*
	For each of the arcticles or resources box, whe need to add an event listener
	click that when you click it it adds it to the favorites of the logged in user///
*/
jQuery(document).on("click", ".save-to-my-content", function () {
	var $ = jQuery;
	var $self = $(this);
	var type = $(this).parent().hasClass("article-box-container") ? "article" : "resource";
	var inistialState = $(this).hasClass("del-from-saved") ? "saved" : "unsaved";
	var postId = $(this).parent().attr("attr-post-id");
	var config = $self.is('[cca-saved-config]') ? JSON.parse($self.attr('cca-saved-config') || '{}') : false;
	var elementContainer = $(this).parent().parent();

	if(config){
		postId = config.post_id;
		type = 'resource';
	}

	if($self.hasClass('not-lg')) return;
	if(postId == "") return;

	var params = {
		action: "update_saved_content", 
		content_type: type,
		post_id: parseInt(postId)
	};

	$.get(window.homeUrl + "/wp-admin/admin-ajax.php", params, function (data) {
		
		var result = JSON.parse(data); // result

		if(result.success){
			if(inistialState === "saved"){
				$self.removeClass("del-from-saved");
				$self.addClass("add-to-saved");
			}else{
				$self.removeClass("add-to-saved");
				$self.addClass("del-from-saved");
				$self.addClass("checked");
			}
		}

		$(window).trigger("cca:updated-saved-content", [parseInt(postId), $self]);
	});

	
});

jQuery(document).on("mouseout", ".save-to-my-content", function() {
	jQuery(this).removeClass("checked");
});

var clicked_strategies = [];
//User Currently working on Strategies in the front end.
jQuery(".currently-working-box").on("click", function(){

	var $ = jQuery; 
	//console.log("currently-working-box clicked");
	var interest_id = parseInt($(this).attr("attr-post-id"));
	//console.log("interest_id", interest_id);
	var strat_color = $(this).attr("attr-strategy-color");
	$(this).toggleClass('selected');
    
	if($(this).hasClass('selected')){
		//$(this).addClass("del-from-saved");
		$(this).css({
			"backgroundColor" : strat_color,
			"color" : "white"
		});
	}else{
		$(this).css({
			"backgroundColor": "transparent",
			"color" : "black" 
		});
	}

});

//When ta save button is clicked we need to call te update currently working function
//and pass the array of strategies ids that where clicked //
jQuery("#save_currently_working").click(function(){

    var $ = jQuery;
	var clicked_strategies = [];
	$('.currently-working-options .currently-working-box.selected').each(function(){
		clicked_strategies.push($(this).attr("attr-post-id"));
	});

    var params = {action: "update_currently_working", post_id: clicked_strategies};
	$.get(window.homeUrl + "/wp-admin/admin-ajax.php", params, function (data) {
		var result = JSON.parse(data); 
		location.reload(true);
	});
});

window.checkBroswerType = function(browser){
	var isChrome = !!window.chrome && !!window.chrome.webstore;
	var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
	var isFirefox = typeof InstallTrigger !== 'undefined';
	var isIE = /*@cc_on!@*/false || !!document.documentMode;
	var isEdge = !isIE && !!window.StyleMedia;
	
	switch (browser) {
		case 'chrome':
			return isChrome;
			break;

		case 'safari':
			return isSafari;
			break;

		case 'firefox':
			return isFirefox;
			break;

		case 'edge':
			return isEdge;
			break;
	
		default:
			return false;
			break;
	}
}



//force boxes to do clamping REDONE: Works on every browser now
window.clampText = function($box) {
	var $ = jQuery;

	var textToClamp = $($box).hasClass("article-box") ? ($box.hasClass('condensed-style') ? $($box).find(".excerpt > p") : $($box).find(".title-container p")) : $($box).find(".excerpt-container p");
	var clampLine = Math.floor($(textToClamp).parent().outerHeight() / parseFloat($(textToClamp).css("line-height")));
	var truncationHTML = false;
	var truncationChar = false;
	
	if($box.hasClass('card-v2')){
		var $link = $($box).find('.card-v2-text-container > h3 > a');
		var linkTarget = $link.attr('target') ? $link.attr('target') : '';
		textToClamp = $($box).find('.card-v2-text-container .excerpt > p');
		clampLine = Math.floor($(textToClamp).parent().outerHeight() / parseFloat($(textToClamp).css("line-height")));
		truncationHTML = '<span>...</span><a href="'+$link.attr('href')+'" target="'+linkTarget+'" class="rm-txt">Read More</a>';
		truncationChar = '&#8203;';
	}

	if(clampLine == 0){
		clampLine = 1;
	}

	$clamp(textToClamp[0], {
		clamp: parseInt(clampLine),
		useNativeClamp: false,
		truncationHTML: truncationHTML,
		truncationChar: truncationChar
	});

	if($box.hasClass('resources-box') && !$box.hasClass('has-featured-image')){
		var $h4 = $box.find('.inner-container > h4');
		var shouldClamp = Math.floor($h4.outerHeight() / parseFloat($h4.css("line-height"))) >= 4;

		if(shouldClamp)
			$clamp($h4[0], { clamp: 4, useNativeClamp: false });
	}

	if($box.hasClass('card-v2')){
		var $title = $($box).find('.card-v2-text-container > h3');
		if(Math.floor($title.height() / parseFloat($title.css("line-height"))) >= 4){
			$clamp($title[0], { clamp: 4, useNativeClamp: false });
		}
	}

	$($box).addClass("clamped");
}

//clamps text inside article an resource box
jQuery(window).ready(function () {
	var $ = jQuery;
	waitForWebfonts(['nimbus-sans', 'korolev-condensed'], function(){
		$(".article-box, .resources-box, .card-v2").not(".clamped").each(function () {
			if(!$(this).hasClass('not-auto-init')){
				window.clampText($(this));
			}
		});
	});
});


// align "other" option of gravity form since there are no selectors

jQuery('input[value="Other"]').parent().css({'verticalAlign' : 'inherit', 'display' : 'inline-block'});

jQuery('input[value="Other"]').css({'verticalAlign' : 'inherit', 'display' : 'inline-block', 'border' : 'none', 'borderBottom' : '3.5px solid #282828', 'fontSize' : '16px', 'fontWeight' : 'bold', 'fontFamily' : 'nimbus-sans', 'boxShadow' : 'none'});


jQuery("[cca-menu-toggle]").on("click", function () {
	var menuIcon = jQuery(this);
	jQuery("[cca-menu]").slideToggle("fast", function() {
		menuIcon.toggleClass("menu-open");
	});
});

jQuery(document).ready(function () {
	var $ = jQuery;
	$("ul#primary-menu").find("li.li-has-children").on("click", function (e) {
		if($(window).width() < 1024){
			//e.preventDefault();
			$(this).find(".children-container").slideToggle("fast", function() {

			});
		}
	});

	$("footer .footer-form input[type='submit']").on("click", function (e) {
		e.preventDefault();
		var postUrl = $(this).parent().attr("action");
		var email = $(this).parent().find("input[type='email']").val();
		var formEl = $(this).parent();

		if( /(.+)@(.+){2,}\.(.+){2,}/.test(email) ){
			$.post(postUrl, {email: email, action: "subscribe_to_newsletter"}, function (resp) {
				formEl.hide();
				formEl.parent().find(".thank-you-signing").show();
			});
		  } else {
			formEl.addClass("invalid");
		  }
	});

	//for footer
	$("footer .footer-form input[type='email']").on("keyup", function () {
		$(this).parent().removeClass("invalid");
		if($(this).val() !== ""){
			$(this).parent().find("input[type='submit']").show();
		}else{
			$(this).parent().find("input[type='submit']").hide();
		}
	});
});

//See if param is set to open popups
jQuery(document).ready(function(){
	var url = new URL(window.location.href);
	var open_action = url.searchParams.get("open_action");
	if(url && open_action){
		switch (open_action) {
			case "login":
				$('#login[data-reveal]').foundation('open');
				break;
			
			case "sign-up":
				$('#signup[data-reveal]').foundation('open');
				break;

			default:
				//silence is golden
				break;
		}
	}
})

function waitForWebfonts(fonts, callback) {
    var loadedFonts = 0;
    for(var i = 0, l = fonts.length; i < l; ++i) {
        (function(font) {
            var node = document.createElement('span');
            // Characters that vary significantly among different fonts
            node.innerHTML = 'giItT1WQy@!-/#';
            // Visible - so we can measure it - but not on the screen
            node.style.position      = 'absolute';
            node.style.left          = '-10000px';
            node.style.top           = '-10000px';
            // Large font size makes even subtle changes obvious
            node.style.fontSize      = '300px';
            // Reset any font properties
            node.style.fontFamily    = 'sans-serif';
            node.style.fontVariant   = 'normal';
            node.style.fontStyle     = 'normal';
            node.style.fontWeight    = 'normal';
            node.style.letterSpacing = '0';
            document.body.appendChild(node);

            // Remember width with no applied web font
            var width = node.offsetWidth;

            node.style.fontFamily = font + ', sans-serif';

            var interval;
            function checkFont() {
                // Compare current width with original width
                if(node && node.offsetWidth != width) {
                    ++loadedFonts;
                    node.parentNode.removeChild(node);
                    node = null;
                }

                // If all fonts have been loaded
                if(loadedFonts >= fonts.length) {
                    if(interval) {
                        clearInterval(interval);
                    }
                    if(loadedFonts == fonts.length) {
                        callback();
                        return true;
                    }
                }
            };

            if(!checkFont()) {
                interval = setInterval(checkFont, 50);
            }
        })(fonts[i]);
    }
};

//Initialize Voting JS
jQuery(document).ready(function(){
	var $ = jQuery;
	
	

	$('body').on('click', '.post-vote-box .thumbs', function(){
		var $this = $(this);
		var $parent = $this.parent();
		var ajaxConfig = JSON.parse($parent.attr('cca-post-vote'));
		var $counter = $this.parent().find('[data-post-vote-counter]');
		var vote = false;
		var oldVote = $parent.hasClass('voted-up') ? 'UP' : ($parent.hasClass('voted-down') ? 'DOWN' : false);

		//IF user is not logged in just show tooltip
		if(!window.hasOwnProperty('cca_vote_post_nonce')){
			$parent.css('pointer-event', 'none').addClass('must-log-in');
			setTimeout(function(){
				$parent.css('pointer-event', '').removeClass('must-log-in');
			}, 3000);
		}else{
			if($this.attr('cca-vote') == 'UP'){
				if($parent.hasClass('voted-up')){
					//remove
					vote = 'REMOVE';
				}else{
					vote = 'UP';
				}
			}else if($this.attr('cca-vote') == 'DOWN'){
				if($parent.hasClass('voted-down')){
					//remove
					vote = 'REMOVE';
				}else{
					vote = 'DOWN';
				}
			}
	
			$parent.addClass('doing-ajax');
	
			$.ajax({
				url: window.homeUrl + "/wp-admin/admin-ajax.php",
				method: 'POST',
				data: {
					action: ajaxConfig.action,
					post_id: ajaxConfig.post_id,
					vote : vote,
					nonce: window.cca_vote_post_nonce
				},
				dataType: 'json'
			}).done(function(resp) {
				if(resp.success){
					console.log('resp', resp);
					if(vote == 'REMOVE'){
						$parent.removeClass('voted-up voted-down');
						
					}else if(vote == 'UP' || vote == 'DOWN'){
						if(vote == 'UP'){
							$parent.removeClass('voted-down').addClass('voted-up');
						}
						if(vote == 'DOWN'){
							$parent.removeClass('voted-up').addClass('voted-down');
						}
					}

					if(['UP', 'DOWN'].indexOf(oldVote) > -1){
						if(vote == 'REMOVE'){
							$counter.html(parseInt($counter.html()) + (oldVote == 'UP' ? -1 : 1));
						}else{
							if(oldVote){
								$counter.html(parseInt($counter.html()) + ((vote == 'UP' ? 1 : -1) + (oldVote == 'UP' ? -1 : 1)));
							}else{
								$counter.html(parseInt($counter.html()) + (vote == 'UP' ? 1 : -1));
							}
						}
					}else{
						$counter.html(parseInt($counter.html()) + (vote == 'UP' ? 1 : -1));
					}
				}
			}).fail(function(jqXHR, textStatus, errorThrown) {
				console.log('There was an error processing your search, please try again later.');
			}).always(function() {
				$parent.removeClass('doing-ajax');
			});
		}

	});



});


jQuery(document).ready(function(){
	var $ = jQuery;

	$.each($('.two-column-box-module-container'), function (i, el) { 
		var $self = $(el);
		var $articlesResourcesSlider = $self.find('.article-resource-slider');

		if($articlesResourcesSlider.length){
			$articlesResourcesSlider.slick({
				arrows: false,
				dots: true,
				infinite: false
			});
		}
	});
})

window.getSamePageAnchor = function(href) {
	var link = document.createElement('a');
	link.href = href;

	/**
	 * For IE compatibility
	 * @see https://stackoverflow.com/a/24437713/1776901
	 */
	var linkCanonical = link.cloneNode(false);

	if (
		linkCanonical.protocol !== window.location.protocol ||
		linkCanonical.host !== window.location.host ||
		linkCanonical.pathname !== window.location.pathname ||
		linkCanonical.search !== window.location.search
	) {
		return false;
	}

	return link.hash;
}

jQuery(document).ready(function(){
	var $ = jQuery;

	var getSelectedOptions = function($options){
		var selectedValues = [];
		$.each($options, function (i, opt) { 
			if($(opt).hasClass('active')){
				selectedValues.push($(opt).attr('data-item-id'));
			}
		});
		return selectedValues;
	}

	$.each($('.tag-buttons-filter'), function (i, el) {
		var $self = $(el);
		var $options = $self.find('[data-item-id]');

		$options.on('click', function(e){
			if($self.hasClass('ajax--is-running')) return;

			var $el = $(e.currentTarget);
			if($el.hasClass('active')){
				$el.removeClass('active');
			}else{
				$el.addClass('active');
			}

			$self.trigger('fri:get-selected', [getSelectedOptions($options)]);
		});

	});
});

jQuery(document).ready(function(){
	var $ = jQuery;

	$.each($('.filter.filter-emit-event'), function (i, el) {
		var $self = $(el);
		$self.on('fri:filter-changed', [$self.find(":selected").val()]);
	});
});

jQuery(document).ready(function(){
	var $ = jQuery;
	$.each($('.card-grid-hero'), function (i, el) {
		var $self = $(el);
		var $loadMore = $self.find('.load-more-btn');
		$loadMore.on('click', function(){
			$loadMore.parent().find('.lazy-load-cards-mobile').addClass('shown');
			$loadMore.addClass('hide');
		});


		var breakpoint = 1175;

		$(window).on('resize cca:resize', function(){
			if($(window).width() <= breakpoint){
				var $cards = $self.find('.desk .card-v2');
				var $responsiveContainer = $self.find('.mobile-container');

				$responsiveContainer.html('');

				$.each($cards, function (i, el) {
					var $el = $(el).clone();
					if(!$el.hasClass('small')){
						$el.addClass('small');
					}
					
					window.clampText($el);

					$responsiveContainer.append($el);
				});
			}
		});

		$(window).trigger('cca:resize');
	});
});